// extracted by mini-css-extract-plugin
export default {"category":"TypeOfFabric_category__KgzcB","header":"TypeOfFabric_header__7QzpM","title":"TypeOfFabric_title__9x4il"};